import { withStyles } from '@material-ui/core';
import { formatAddress } from '../../../../../utils/utils';
import { formatMonthDateYearWithoutUTC } from '@dataGrid/gridUtilities';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    columnGap: '18px',
    rowGap: '6px',
    margin: '14 0 16 0'
  },
  detailRow: {
    flexDirection: 'column',
    minWidth: '66px'
  },
  label: {
    color: theme.recommendationCardStatusTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
  },
  value: {
    marginTop: 4,
    wordBreak: 'break-word',
    maxWidth: 250,
    color: theme.gridTextColor,
    fontSize: theme.headerTextFontSize,
    fontWeight: 500
  },
  address: {
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight: '16px',
    color: theme.recommendationCardStatusTextColor
  }
});

const DetailItem = ({ label, value, classes }) => (
  <div className={classes.detailRow}>
    <div className={classes.label}>{label}</div>
    <div className={classes.value}>{value || 'N/A'}</div>
  </div>
);

const PickupDetails = ({ classes, pickupInfo = {} }) => {
  const address = formatAddress({
    address: pickupInfo?.shipperAddress,
    city: pickupInfo?.shipperCity,
    state: pickupInfo?.shipperState,
    zip: pickupInfo?.shipperZip
  });

  return (
    <div className={classes.container}>
      <DetailItem label="Pickup#" value={pickupInfo.pickupNumber} classes={classes} />
      <div>
        <DetailItem label="Shipper" value={pickupInfo.shipperName} classes={classes} />
        {address && <div className={classes.address}>{address}</div>}
      </div>
      <DetailItem label="Ready Time" value={pickupInfo.pickupReadyTime} classes={classes} />
      <DetailItem label="Close Time" value={pickupInfo.pickupCloseTime} classes={classes} />
      <DetailItem
        label="Pickup Date"
        value={formatMonthDateYearWithoutUTC({ value: pickupInfo.pickupDate })}
        classes={classes}
      />
    </div>
  );
};

export default withStyles(styles)(PickupDetails);
